angular
    .module('tradersyard')
    .factory('webinar-settings-filter', [
        '$flex',
        function ($flex) {
            var tab,
                hash,
                filter = {
                    init: function () {
                        hash = $flex.$hash.get();

                        tab = ['general', 'roles', 'blacklist'].indexOf(hash) !== -1 ? hash : 'general';

                        filter.set(tab);
                    },
                    is: function (name) {
                        return tab === name;
                    },
                    set: function (name) {
                        tab = name;

                        if (filter.on.change) filter.on.change();

                        $flex.$touch.make(name);

                        if ($flex.$hash.get() !== name) $flex.$hash.set(name);
                    },
                    tab: function () {
                        return tab;
                    },
                    on: {
                        change: undefined,
                    },
                };

            return filter;
        },
    ])
    .controller('webinar-settings-ctrl', [
        '$scope',
        'graph-webinar-factory',
        'webinar-settings-filter',
        'graph-invite-factory',
        'datetime-common',
        'graph-search-factory',
        '$flex',
        function ($scope, $factory, $filter, $invite, $common, $search, $flex) {
            $scope.node = {};
            $scope.exhibition = undefined;
            $scope.filter = $filter;
            $scope.blacklists = {
                page: 0,
                data: [],
            };
            $scope.participants = {
                page: 0,
                data: [],
            };
            $scope.invites = {
                page: 0,
                data: [],
            };
            $scope.roles = {
                owner: {
                    page: 0,
                    data: [],
                },
                executive: {
                    page: 0,
                    data: [],
                },
                presenter: {
                    page: 0,
                    data: [],
                },
                trader: {
                    page: 0,
                    data: [],
                },
                pretrader: {
                    page: 0,
                    data: [],
                },
                listener: {
                    page: 0,
                    data: [],
                },
            };
            $scope.current_role = undefined;

            $scope.roleDictionary = {
                owner: ['owner', 'presenter', 'pretrader', 'listener'],
                presenter: ['presenter', 'pretrader', 'listener'],
            };

            $scope.user = {
                search: function ($q) {
                    $scope.participants.data = [];
                    $search
                        .entry('user')
                        .search({ params: $q })
                        .then(function (response) {
                            if (response.data.state === 0 && response.data.data.length > 0) {
                                $scope.participants.data = response.data.data;
                            }
                        });
                },
            };
            $scope.invite = {
                search: function (q) {
                    $scope.invites.page = 0;
                    $scope.invites.data = [];
                    $scope.invite.query(q)();
                    $flex.$scroll.renew('roles');
                },
                query: function (q) {
                    return function (next) {
                        if (q === undefined || q === '') {
                            $scope.invite.find(next);
                            return;
                        }

                        ++$scope.invites.page;
                        var options = {
                            q: q,
                            page: $scope.invites.page,
                        };

                        $search
                            .place('webinar', $scope.node.id)
                            .search('invite', { params: options })
                            .then(function (response) {
                                if (response.data.state === 0 && response.data.data.length > 0) {
                                    $scope.invites.data = $scope.invites.data.concat(response.data.data);

                                    if (next) next();
                                }
                            });
                    };
                },
                find: function (next) {
                    ++$scope.invites.page;
                    var options = {
                        page: $scope.invites.page,
                    };

                    $invite
                        .entry('webinar', $scope.node.id)
                        .query({ params: options })
                        .then(function (response) {
                            if (response.data.state === 0 && response.data.data.length > 0) {
                                $scope.invites.data = $scope.invites.data.concat(response.data.data);

                                if (next) next();
                            }
                        });
                },
            };
            $scope.blacklist = {
                query: function (next) {
                    var params = {
                        page: ++$scope.blacklists.page,
                    };

                    $factory
                        .blacklists($scope.node.id)
                        .query({ params: params })
                        .then(function (response) {
                            if (response.data.state === 0 && response.data.data.length > 0) {
                                $scope.blacklists.data = $scope.blacklists.data.concat(response.data.data);
                                if (next) next();
                            }
                        });
                },
                insert: function (user) {
                    $factory
                        .blacklists($scope.node.id)
                        .insert(user.id)
                        .then(function (response) {
                            if (response.data.state === 0) {
                                for (var i in $scope.participants.data) {
                                    if ($scope.participants.data[i].id === user.id) {
                                        $scope.participants.data.splice(i, 1);
                                    }
                                }
                                $scope.blacklists.data = $scope.blacklists.data.concat(user);
                            }
                        });
                },
                delete: function (user) {
                    $factory
                        .blacklists($scope.node.id)
                        .delete(user.id)
                        .then(function (response) {
                            if (response.data.state === 0) {
                                for (var i in $scope.blacklists.data) {
                                    if ($scope.blacklists.data[i].id === user.id) {
                                        $scope.blacklists.data.splice(i, 1);
                                    }
                                }
                            }
                        });
                },
            };
            $scope.participant = {
                search: function (q) {
                    $scope.participants.page = 0;
                    $scope.participants.data = [];
                    $scope.participant.sQuery(q)();
                    $flex.$scroll.renew('roles');
                },
                sQuery: function (q) {
                    return function (next) {
                        if (q === '') {
                            $scope.participant.find(next);
                            return;
                        }

                        ++$scope.participants.page;
                        var options = {
                            q: q,
                            page: $scope.participants.page,
                            place: 'webinar.' + $scope.node.id,
                        };

                        $search
                            .place('webinar', $scope.node.id)
                            .search('participant', { params: options })
                            .then(function (response) {
                                if (response.data.state === 0 && response.data.data.length > 0) {
                                    $scope.participants.data = $scope.participants.data.concat(response.data.data);

                                    if (next) next();
                                }
                            });
                    };
                },
                query: function (role) {
                    if ($scope.current_role !== role) {
                        $flex.$scroll.renew('roles');
                        $scope.current_role = role;
                    }

                    return function (next) {
                        ++$scope.roles[role].page;
                        var options = {
                            roles: role,
                            page: $scope.roles[role].page,
                        };

                        $factory
                            .participants($scope.node.id)
                            .query({ params: options })
                            .then(function (response) {
                                if (response.data.state === 0 && response.data.data.length > 0) {
                                    $scope.roles[role].data = $scope.roles[role].data.concat(response.data.data);

                                    if (next) next();
                                }
                            });
                    };
                },
                find: function (next) {
                    $flex.$scroll.renew('roles');
                    $scope.participant.query('owner')();
                    $scope.participant.query('presenter')();
                    $scope.participant.query('pretrader')();
                    $scope.participant.query('listener')();
                },
            };

            $scope.changeMode = function (mode) {
                if (['participant', 'invite'].indexOf(mode) === -1) return;

                if (mode === $scope.ui.mode) return;

                $scope.search = '';

                switch (mode) {
                    case 'invite':
                        $scope.invites.page = 0;
                        $scope.invites.data = [];

                        $scope.invite.find();
                        break;
                    case 'participant':
                        $scope.participant.find();
                        break;
                }

                $scope.ui.mode = mode;
            };

            $scope.filter.on.change = function () {
                $flex.$scroll.switch($scope.filter.tab());
                $scope.participants.data = [];
            };

            $scope.$error = {};
            $scope.buffer = {};
            $scope.$datetime = $common;
            $scope.duration = 0;
            $scope.queue = 0;
            $scope.diffed = 0;
            $scope.ui = {
                cancel: 0,
                mode: 'participant',
            };

            $scope.languages = {
                en: false,
                de: false,
                ru: false,
            };

            $scope.langcheck = function (code) {
                var index = $scope.node.languages.indexOf(code);

                if (index !== -1) {
                    $scope.node.languages.splice(index, 1);
                } else {
                    $scope.node.languages.push(code);
                }
            };

            $scope.is12 = $common.is12;
            $scope.is24 = $common.is24;

            $scope.calculate = function (moved) {
                var started_at = $common.gather($scope.node.started_at),
                    ended_at = $common.gather($scope.node.ended_at);

                if (moved === true) ended_at = started_at.clone().add($scope.diffed, 's');

                $scope.node.started_at = $common.parse(started_at);

                $scope.node.ended_at = $common.parse(ended_at);

                if ($scope.node.technology === 'choop-chat') {
                    $scope.node.technology_url = '';
                }

                $scope.diffed = $common.diff(started_at, ended_at) / 1000;

                if ($scope.update.form.started_at_time && $scope.update.form.started_at_time.$touched) {
                    $scope.update.form.started_at_time.$setValidity('future', $common.diff(moment(), started_at) > 0);
                }

                if ($scope.update.form.ended_at_time && $scope.update.form.ended_at_time.$touched) {
                    $scope.update.form.ended_at_time.$setValidity('future', $common.diff(started_at, ended_at) > 0);
                }

                $scope.update.form.languages.$setValidity(
                    'languages',
                    Object.values($scope.languages).indexOf(true) != -1
                );

                $scope.duration = $common.duration(started_at, ended_at).humanize();
            };

            $scope.validate = function (data) {
                var executions = data.executions.map(function (execution) {
                    return {
                        id: execution.id,
                        started_at: $common.gather(execution.started_at),
                        ended_at: $common.gather({ date: execution.started_at.date, time: execution.ended_at.time }),
                    };
                });

                $scope.buffer = {
                    name: data.name,
                    description: data.description,
                    languages: data.languages,
                    vanity_name: data.vanity_name,
                    privacy: data.privacy,
                    stream_url: data.stream_url,
                    technology: data.technology,
                    technology_url: data.technology_url,
                    sponsoring: data.sponsoring,
                    executions: executions,
                };

                if ($scope.exhibition) {
                    $scope.buffer.exhibition_id = $scope.exhibition.id;
                    $scope.buffer.speaker_hall_id = $scope.exhibition.speaker_hall_id;
                    $scope.buffer.sponsoring = $scope.node.sponsoring;
                }

                return true;
            };

            $scope.cuttedList = true;
            $scope.limitToExecutions = 40;

            $scope.expandExecutions = function () {
                $scope.cuttedList = false;
                $scope.limitToExecutions = $scope.node.executions.length;
            };

            $scope.addSession = function (idToScroll) {
                $scope.expandExecutions();

                var started_at, ended_at;
                var lastExecution = $scope.node.executions[$scope.node.executions.length - 1];

                if (lastExecution) {
                    started_at = $common.gather(lastExecution.started_at);
                    started_at.add(1, 'd');

                    ended_at = $common.gather(lastExecution.ended_at);
                    ended_at.add(1, 'd');
                } else {
                    started_at = $common.default.start.clone();
                    started_at.add(1, 'd');

                    ended_at = $common.default.end.clone();
                    ended_at.add(1, 'd');
                }

                $scope.node.executions.push({
                    id: 0,
                    started_at: $common.parse(started_at),
                    ended_at: $common.parse(ended_at),
                });

                if (idToScroll) {
                    var objDiv = document.querySelector(idToScroll);
                    objDiv.scrollTop = objDiv.scrollHeight;
                }

                setTimeout(function () {
                    if (idToScroll) {
                        var objDiv = document.querySelector(idToScroll);
                        objDiv.scrollTop = objDiv.scrollHeight;
                    }
                }, 100);

                $scope.limitToExecutions = $scope.node.executions.length;
            };

            $scope.removeSession = function (index) {
                $scope.node.executions.splice(index, 1);
                $scope.limitToExecutions = $scope.node.executions.length;
            };

            $scope.submit = function () {
                if ($scope.validate($scope.node) === true && $scope.queue === 0) {
                    $scope.queue = 1;

                    if ($scope.node.reopen) {
                        $scope.reopen($scope.buffer);
                    } else {
                        $scope.update($scope.buffer);
                    }
                }
            };

            $scope.errors = {};

            $scope.cancel = function (node) {
                $factory.cancel(node.id).then(function (response) {
                    if (response.data.state === 0) {
                        window.location.replace('/webinar/' + $scope.node.id);
                    }
                });
            };

            $scope.update = function (data) {
                $scope.errors = {};

                $factory.update($scope.node.id, data).then(function (response) {
                    if (response.data.state === 0) {
                        window.location.replace('/webinar/' + $scope.node.id);
                    } else {
                        $scope.queue = 0;
                        $scope.errors = response.data.data;
                        window.scrollTo(0, 0);
                    }
                });
            };

            $scope.node.reopen = false;

            $scope.reopen = function (data) {
                $scope.errors = {};

                data.status = 'registration';

                $factory.update($scope.node.id, data).then(function (response) {
                    if (response.data.state === 0) {
                        window.location.replace('/webinar/' + $scope.node.id);
                    } else {
                        $scope.queue = 0;
                        $scope.errors = response.data.data;
                        window.scrollTo(0, 0);
                    }
                });
            };

            $scope.relatedProduct = { url: '' };
            $scope.relatedProducts = [];
            $scope.addRelatedProduct = function () {
                var relatedProductUrl = $scope.relatedProduct.url;
                $scope.relatedProductError = undefined;
                $scope.relatedProduct.url = '';

                $factory.addRelatedProduct($scope.node.id, relatedProductUrl).then(
                    function (response) {
                        if (response.data.state === 0) {
                            var index = ($scope.relatedProducts || [])
                                .map(function (relatedProduct) {
                                    return relatedProduct.id;
                                })
                                .indexOf(response.data.data.id);

                            if (index < 0) {
                                $scope.relatedProducts = ($scope.relatedProducts || []).concat([response.data.data]);
                            }
                        } else {
                            $scope.relatedProductError = response.data.data.url;
                            $scope.relatedProduct.url = relatedProductUrl;
                        }
                    },
                    function (error) {
                        $scope.relatedProductError = 'An error occurred';
                        $scope.relatedProduct.url = relatedProductUrl;
                    }
                );
            };

            $scope.removeRelatedProduct = function (linkId) {
                $factory.removeRelatedProduct($scope.node.id, linkId).then(function (response) {
                    var index = ($scope.relatedProducts || [])
                        .map(function (relatedProduct) {
                            return relatedProduct.id;
                        })
                        .indexOf(linkId);

                    if (index >= 0) {
                        $scope.relatedProducts.splice(index, 1);
                    }
                });
            };

            $scope.$on('touch:general', function () {
                // angular.extend($scope.node);

                var languages = [];

                $scope.node.languages.forEach(function (code) {
                    languages.push(code.code);
                    $scope.languages[code.code] = true;
                });

                $scope.node.executions = $scope.node.executions.map(function (execution) {
                    execution.started_at = $common.parse(moment(execution.started_at));
                    execution.ended_at = $common.parse(moment(execution.ended_at));
                    return execution;
                });

                $scope.node.languages = languages;

                $factory.queryRelatedProducts($scope.node.id).then(function (response) {
                    $scope.relatedProducts = response.data.data;
                });

                // setTimeout($scope.calculate, 0);
            });

            $scope.$on('touch:roles', function () {
                $scope.participant.find();
            });

            $scope.$on('touch:blacklist', function () {
                $scope.blacklist.query();
            });

            $scope.$on('$historyBack', $filter.init);
        },
    ]);
